import * as React from 'react';
import { ActionButton } from '../../../../Button';
import { useTheme } from '../../../../theme';
import cn from 'classnames';

interface Props {
	loading: boolean;
	children: React.ReactNode;
}

const SubmitButton: React.FC<Props> = ({ loading, children }) => {
	const { SubmitButton: css } = useTheme('LoginPage');

	return (
		<ActionButton
			disabled={loading}
			type={'submit'}
			data-test-id="login-submit"
			className={cn(css.root, {
				[css.loading]: loading
			})}
		>
			<span className={css.content}>{children}</span>
		</ActionButton>
	);
};

export default SubmitButton;
